<div class="footer" role="navigation">

  <div class="footer-left">
    <a class="social" href="https://x.com/SpaceX" target="_blank" aria-label="SpaceX X">
      <button type="button"><x-social-svg></x-social-svg></button>
    </a>
    <div class="grok-lockup" *ngIf="showGrokCredit" aria-label="Designed and built with Grok">
      <span>Designed and built with</span>
      <img src="assets/images/Grok_Logo.svg" alt="Grok" />
    </div>
  </div>

  <!-- Navigation links. -->
  <nav>
    <a routerLink="/careers" aria-label="SpaceX careers page">Careers</a>
    <a routerLink="/updates" aria-label="SpaceX updates page">Updates</a>
    <a href="assets/media/privacy_policy_spacex.pdf" target="_blank" aria-label="SpaceX Privacy Policy">Privacy Policy</a>
    <a routerLink="/supplier" aria-label="Information for SpaceX suppliers">Suppliers</a>
    <a href="https://ir.spacex.com" target="_blank" rel="noopener noreferrer" aria-label="Go to investor relations page">Investors</a>
  </nav>

  <!-- @2026 SpaceX. -->
  <div class="footer-text">
    © 2026 SpaceX
  </div>
</div>
